var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h25v25H0z","key":0}),React.createElement("g",{"stroke":"black","className":"close-stroke","strokeLinecap":"square","key":1},React.createElement("path",{"d":"M9 8l8 8M17 8l-8 8"}))]));
}

Close.defaultProps = {"width":"25","height":"25"};

module.exports = Close;

Close.default = Close;
